import { render, staticRenderFns } from "./SOPrice.vue?vue&type=template&id=7e7b749b&"
import script from "./SOPrice.vue?vue&type=script&lang=ts&"
export * from "./SOPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports